import { createAction } from 'helpers/redux-actions.helper'
import { ActionsUnion } from 'helpers/types.helper'

export const CAN_COURSE = 'CAN_COURSE'
export const CAN_COURSE_SUCCESS = 'CAN_COURSE_SUCCESS'

export const Actions = {
  canCourse: (courseId: number) => createAction(CAN_COURSE, courseId),
  canCourseSuccess: (data: any) => createAction(CAN_COURSE_SUCCESS, data),
}

export type Actions = ActionsUnion<typeof Actions>
